import {NavLink} from 'react-router-dom';
import {Button, Tag, Typography} from 'antd';
import {ColumnsType} from 'antd/es/table';
import {t} from 'i18next';
import {AppRoutePaths} from 'routing/Routes';
import {AssigneeDto, ServiceStatus, ServiceTaskListDto} from '../../../../../../PRMGApiClient';
import {DateFilterDropdown, DatetimeColumn, getStatusColor} from './ServicesUtils';

export const serviceTasksColumns: ColumnsType<ServiceTaskListDto> = [
  {
    title: t('Task name'),
    dataIndex: 'name',
    key: 'name',
    render: (text, record) => (
      <Button type="link" className="p-0">
        <NavLink to={`${AppRoutePaths.tasks.url}/${record.id}`}>{text}</NavLink>
      </Button>
    ),
  },
  {
    title: t('Start date'),
    key: 'startDateTime',
    dataIndex: 'startDateTime',
    sorter: true,
    render: DatetimeColumn,
    filterDropdown: (props) => <DateFilterDropdown dataIndex="startDateTime" {...props} />,
  },
  {
    title: t('End date'),
    key: 'endDateTime',
    dataIndex: 'endDateTime',
    sorter: true,
    render: DatetimeColumn,
    filterDropdown: (props) => <DateFilterDropdown dataIndex="endDateTime" {...props} />,
  },
  {
    title: t('Assigned to'),
    key: 'assignee',
    dataIndex: 'assignee',
    sorter: true,
    render: (assignee: AssigneeDto) => (
      <Typography.Text strong>
        {assignee.firstName} {assignee.lastName}
      </Typography.Text>
    ),
  },
  {
    title: t('Status'),
    key: 'status',
    dataIndex: 'status',
    filters: Object.keys(ServiceStatus).map((key) => ({text: key, value: key})),
    sorter: true,
    render: (text) => <Tag color={getStatusColor(text)}>{text}</Tag>,
  },
];
